import { MsalProvider } from '@azure/msal-react';
import { Toaster } from 'react-hot-toast';
import { QueryClient, QueryClientProvider } from 'react-query';

import { appWithTranslation } from 'next-i18next';
import type { AppProps } from 'next/app';
import { Inter } from 'next/font/google';
import Head from 'next/head';

import { msalConfig } from '@/authConfig';
import '@/styles/globals.css';
import {
  AccountInfo,
  EventType,
  PublicClientApplication,
} from '@azure/msal-browser';

const inter = Inter({ subsets: ['latin'] });
const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize();

if (
  !msalInstance.getActiveAccount() &&
  msalInstance.getAllAccounts().length > 0
) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.addEventCallback((event: any) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    if ('account' in event.payload) {
      const account = event.payload.account;
      msalInstance.setActiveAccount(account ?? msalInstance.getActiveAccount());
    }
  }

  if (event.eventType === EventType.LOGOUT_SUCCESS) {
    if (msalInstance.getAllAccounts().length > 0) {
      msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
    }
  }
});

function App({ Component, pageProps }: AppProps<{}>) {
  const queryClient = new QueryClient();

  return (
    <div className={inter.className}>
      <Head>
        <title>KAIWA | KPS</title>
      </Head>
      <MsalProvider instance={msalInstance}>
        <Toaster />
        <QueryClientProvider client={queryClient}>
          <Component {...pageProps} />
        </QueryClientProvider>
      </MsalProvider>
    </div>
  );
}
export { msalInstance };

export default appWithTranslation(App);
